module.exports = __webpack_public_path__ + "media/pied-billed-grebe-3.285d3b95.mp3";